export function getPriorityText(priority: number): string {
  switch (priority) {
    case 1:
      return 'Low';
    case 2:
      return 'Normal';
    case 3:
      return 'High';
    case 4:
      return 'Imperative';
    default:
      return '';
  }
}
